import BestMedSupInRegion from '@components/seo/medsup/BestMedSupInRegion';
import { medigapStateData } from '@components/seo/medsup/data/msStateData';

import { Routes } from '@constants/routes';
import { getPublishDate } from '@utils/index';
import { decodeSlug } from '@utils/slugs';
import { NextSeo } from 'next-seo';
import { titleCase } from 'title-case';
import { fsmApi } from '../../../lib/requests';

const BestMedSupPage = ({ index = null, stateData = null, cityList = [] }) => {
  const title = `Best Medicare Supplement Plans in ${stateData.state} for 2025`;
  const description = `Best Medicare Supplement Plans in ${stateData.state} for 2025`;
  const alt = `Scene of ${titleCase(stateData.state)}`;

  const publishDate = getPublishDate(index);

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          type: 'website',
          locale: 'en-US',
          title,
          description,
          url: `https://www.fairsquaremedicare.com/best-medicare-supplement/${stateData.state
            .toLowerCase()
            .replace(/ /g, '-')}`,
          site_name: 'Fair Square Medicare',
          article: {
            publishedTime: publishDate.toISOString(),
            modifiedTime: publishDate.toISOString(),
            tags: ['medicare', 'supplement', stateData.state.toLowerCase(), '2025'],
          },
          images: [
            {
              url: stateData.image,
              width: 1200,
              height: 630,
              alt,
            },
          ],
        }}
      />
      <BestMedSupInRegion
        data={{
          ...stateData,
          name: stateData.state,
          alt,
          publishDate,
          title,
          cityList,
        }}
      />
    </>
  );
};

export async function getServerSideProps({ params }) {
  const state = decodeSlug(params.stateSlug);
  const index = medigapStateData.findIndex((stateData) => titleCase(stateData.state) === state);

  // If invalid slug redirect
  if (index === -1) {
    return {
      redirect: {
        destination: Routes.bestMedicareSupplement,
        permanent: false,
      },
    };
  }
  const stateData = {
    ...medigapStateData[index],
    state: titleCase(medigapStateData[index].state),
  };

  try {
    const citiesRes = await fsmApi.get(`/blog/cities/${stateData.stateCode}?limit=50`);

    return {
      props: {
        index,
        cityList: citiesRes.data,
        stateData,
      },
    };
  } catch (error) {
    return {
      props: {
        index: null,
        cityList: null,
        stateData,
      },
    };
  }
}

export default BestMedSupPage;
